import React from 'react';

const SantoTipoHome = () => {
  return (
    <div>
      <h1>Santo Tipo Inicio</h1>
      {/* Add your content here */}
    </div>
  );
};

export default SantoTipoHome;
